import { useFeatureFlags } from '@cosuno/feature-flags-frontend';
import type { PriceDetails } from '@cosuno/utils';
import { useCallback } from 'react';

function usePreferGrossTotals() {
  return useFeatureFlags()['conditional-prefer-gross-totals'];
}

export function useGetBidGrossOrNetTotalBasedOnFeatureFlag() {
  const preferGrossTotals = usePreferGrossTotals();
  return useCallback(
    (details: PriceDetails) => details[preferGrossTotals ? 'totalGross' : 'totalNetWithDiscount'],
    [preferGrossTotals],
  );
}
